import axios from "axios";
import Cookies from "js-cookie";
const csrfToken = Cookies.get("csrftoken");

const createAbortController = () => new AbortController();

const protocol = window.location.protocol;
// Set the API URL based on the protocol
const API_URL =
  protocol === "http:"
    ? process.env.REACT_APP_API_URL
    : process.env.REACT_APP_API_URL_PROD;

async function fetchData(url, token, signal) {
  try {
    const response = await axios.get(url, {
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `token ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error.response };
  }
}

async function fetchBlobData(url, token) {
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `token ${token}`,
      },
      responseType: "blob",
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error.response };
  }
}
async function fetchWithoutTokenData(url, signal) {
  try {
    const response = await axios.get(url, {
      headers: { "X-CSRFToken": csrfToken, "Content-Type": "application/json" },
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error.response };
  }
}

async function PostData(url, data, signal) {
  try {
    const response = await axios.post(url, data, { signal });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error?.response };
  }
}
async function PostDatawithToken(url, data, token, signal) {
  try {
    const response = await axios.post(url, data, {
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `token ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error?.response };
  }
}
async function PostDataMultiForm(url, data, token, signal) {
  try {
    const response = await axios.post(url, data, {
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `token ${token}`,
        "Content-Type": "multipart/form-data",
      },
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error?.response };
  }
}

async function PostwithotDatawithToken(url, token, signal) {
  try {
    const response = await axios.post(
      url,
      {},
      {
        headers: {
          "X-CSRFToken": csrfToken,
          Authorization: `token ${token}`,
          "Content-Type": "application/json",
        },
        signal,
      }
    );
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error.response };
  }
}
async function patchData(url, data, token, signal) {
  try {
    const response = await axios.patch(url, data, {
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `token ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error?.response };
  }
}

async function putData(url, data, token, signal) {
  try {
    const response = await axios.put(url, data, {
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `token ${token}`,
        "Content-Type": "application/json",
      },
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error.response };
  }
}
async function PutDataMultiForm(url, data, token, signal) {
  try {
    const response = await axios.put(url, data, {
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `token ${token}`,
        "Content-Type": "multipart/form-data",
      },
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error?.response };
  }
}

async function deletData(url, data, token, signal) {
  try {
    const response = await axios.delete(url, {
      headers: {
        "X-CSRFToken": csrfToken,
        Authorization: `Token ${token}`, // Note: Make sure the token type is correct, e.g., 'Bearer' or 'Token'
        "Content-Type": "application/json",
      },
      data, // Data should be part of config, not the second argument of delete
      signal,
    });
    return { status: true, response: response.data };
  } catch (error) {
    return { status: false, response: error.response };
  }
}

export function logout_user(token) {
  const abortController = createAbortController();
  const apiUrl = `${API_URL}logout/`;
  return PostDatawithToken(apiUrl, {}, token, abortController.signal).finally(
    () => abortController.abort()
  );
}

export function loginuser(data, signal) {
  const apiUrl = `${API_URL}login/`;
  return PostData(apiUrl, data, signal);
}
export function get_user_detail_by_token(token, user_id, signal) {
  let apiUrl = `${API_URL}users-detail/?`;
  const params = [];
  if (user_id) params.push(`user_id=${user_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ====================assign -fee================
export function get_user_assign_fee_brakdown(
  token,
  student_id,
  session_id,
  school_id,
  signal
) {
  let apiUrl = `${API_URL}assign-student-fee/?`;
  const params = [];
  if (student_id) params.push(`student_id=${student_id}`);
  if (session_id) params.push(`session_id=${session_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function assign_user_to_fee_package(
  data,
  session_id,
  token,
  school_id,
  signal
) {
  let apiUrl = `${API_URL}assign-student-fee/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (session_id) params.push(`session_id=${session_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function remove_user_to_fee_package(data, token, signal) {
  const apiUrl = `${API_URL}assign-student-fee/`;
  return deletData(apiUrl, data, token, signal);
}
export function add_transport_fee(data, token, session_id, school_id, signal) {
  let apiUrl = `${API_URL}add-transport-fee/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (session_id) params.push(`session_id=${session_id}`);
  apiUrl += params.join("&");
  // const apiUrl = `${API_URL}add-transport-fee/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function remove_transport(data, token, signal) {
  const apiUrl = `${API_URL}add-transport-fee/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_fee_report(
  school_class,
  section,
  session,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-fee-report/?`;
  const params = [];
  if (school_class) params.push(`school_class=${school_class}`);
  if (session) params.push(`session_id=${session}`);
  if (section) params.push(`section=${section}`);
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_defaulter_fee_report(
  school_class,
  section,
  session,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}/?`;
  const params = [];
  if (school_class) params.push(`school_class=${school_class}`);
  if (session) params.push(`session_id=${session}`);
  if (section) params.push(`section=${section}`);
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_defaulter_fee_type(
  school_class,
  section,
  session,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}defaulter-feetype-list/?`;
  const params = [];
  if (school_class) params.push(`school_class=${school_class}`);
  if (session) params.push(`session_id=${session}`);
  if (section) params.push(`section=${section}`);
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// =====================================pay============================================
export function pay_fee(data, token, school_id, signal) {
  const apiUrl = `${API_URL}pay/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function undo_pay_fee(id, token, school_id, signal) {
  let apiUrl = `${API_URL}pay/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (id) params.push(`id=${id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, "", token, signal);
}
// ============================role base and users==================================================
export function get_role_base_user(
  section_id,
  class_id,
  role,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}user-list/?`;
  const params = [];
  if (section_id) params.push(`section_id=${section_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (role) params.push(`role=${role}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================image uupload=================================================
export function user_image_upload(data, school_id, token, signal) {
  const apiUrl = `${API_URL}user-upload-image/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function user_document_upload(data, school_id, token, signal) {
  const apiUrl = `${API_URL}user-documents/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function get_user_document(user_id, school_id, token, signal) {
  let apiUrl = `${API_URL}user-documents/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (user_id) params.push(`user_id=${user_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function delete_user_document(data, token, signal) {
  const apiUrl = `${API_URL}user-documents/`;
  return deletData(apiUrl, data, token, signal);
}
//==========================================entrance========================================
// export function post_Entrance(data,token,signal,user_id) {
//   const  apiUrl  = `${API_URL}assessments/${user_id}/`;
//    return PostDatawithToken(apiUrl,data,token,signal);
//  }

//  export function get_Entrance(){
//   let apiUrl = `${API_URL}assessments/?`;
//   const params = [];
//   if (school_id) params.push(`school_id=${school_id}`);
//   if (user_id) params.push(`user_id=${user_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
//  }

// ==================================reset user password====================================
export function reset_password(data, token, signal, user_id) {
  const apiUrl = `${API_URL}reset-password/${user_id}/`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
// =======================================sims_config==============================================
export function post_sims_config(data, school_id, token, signal) {
  let apiUrl = `${API_URL}sims-config/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function get_sims_config(token, key, school_id, signal) {
  let apiUrl = `${API_URL}sims-config/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (key) params.push(`key=${key}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function update_sims_config(data, token, school_id, signal) {
  let apiUrl = `${API_URL}sims-config/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_sims_config(data, token, school_id, signal) {
  let apiUrl = `${API_URL}sims-config/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
// ===============================model permissions====================================
export function get_model_permission(token, school_id, signal) {
  let apiUrl = `${API_URL}model-permissions/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_model_role_permission(token, role_all, school_id, signal) {
  let apiUrl = `${API_URL}model-permissions/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (role_all) params.push(`role_all=${role_all}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_model_permission(data, school_id, token, signal) {
  const apiUrl = `${API_URL}model-permissions/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function get_role_wise_check_per(data, school_id, token, signal) {
  let apiUrl = `${API_URL}role-wise-check/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function add_role_wise_permission(data, school_id, token, signal) {
  let apiUrl = `${API_URL}role-wise-perm/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
// =======================app and appitem permission==============

export function get_apps(token, permission_model, permission_role, signal) {
  let apiUrl = `${API_URL}apps-permissions/?`;
  const params = [];
  if (permission_model) params.push(`permission_show=${permission_model}`);
  if (
    permission_role !== undefined &&
    permission_role !== null &&
    permission_role !== ""
  )
    params.push(`permission_role=${permission_role}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_permission_user_list(token, signal, school_id, role) {
  let apiUrl = `${API_URL}user-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (role) params.push(`role=${role}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_apps_by_user(
  token,
  signal,
  user_id,
  role,
  permission_model
) {
  let apiUrl = `${API_URL}apps-permissions/${user_id}/${role}/?`;
  const params = [];
  if (permission_model) params.push(`permission_show=${permission_model}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function update_permission(
  token,
  signal,
  school_id,
  permission_model,
  app_id,
  role_name
) {
  let apiUrl = `${API_URL}app-permissions-update/?`;
  const params = [];
  if (app_id) params.push(`app_id=${app_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (role_name) params.push(`role_name=${role_name}`);
  if (permission_model) params.push(`permission_model=${permission_model}`);
  apiUrl += params.join("&");
  return PostwithotDatawithToken(apiUrl, token, signal);
}

export function check_permission(data, token, school_id, signal) {
  let apiUrl = `${API_URL}token-permission/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function ckeck_token_auth(data) {
  const apiUrl = `${API_URL}token-valid/`;
  return PostData(apiUrl, data);
}
// ===============================Maintenance=============================
export function get_maintenance(page, page_size, search, token, signal) {
  let apiUrl = `${API_URL}maintenance/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (search) params.push(`search=${search}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_maintenance(data, token, signal) {
  let apiUrl = `${API_URL}maintenance/`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_maintenance(data, token, signal) {
  let apiUrl = `${API_URL}maintenance/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_maintenance(data, token, signal) {
  let apiUrl = `${API_URL}maintenance/`;
  return deletData(apiUrl, data, token, signal);
}
export function fetchMaintenanceStatus(signal) {
  let apiUrl = `${API_URL}maintenance-status/`;
  return fetchWithoutTokenData(apiUrl, signal);
}
// ==================================school code check========================
export function school_code_valid(data) {
  const apiUrl = `${API_URL}school-code-valid/`;
  return PostData(apiUrl, data);
}

// ===========================school detail===================
export function get_school_login_page_detail(school_code, signal) {
  const apiUrl = `${API_URL}school-detail/${school_code}/`;
  return fetchWithoutTokenData(apiUrl, signal);
}
//   =======================get class ===============================
export function get_classes(
  page,
  page_size,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}classes/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_classes(data, school_id, token, signal) {
  const apiUrl = `${API_URL}classes/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_classes(data, school_id, token, signal) {
  const apiUrl = `${API_URL}classes/?school_id=${school_id}`;
  return putData(apiUrl, data, token, signal);
}
export function delete_classes(data, school_id, token, signal) {
  const apiUrl = `${API_URL}classes/?school_id=${school_id}`;
  return deletData(apiUrl, data, token, signal);
}
export function get_classes_list(school_id, token, signal) {
  const apiUrl = `${API_URL}class-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}

//   =======================get section ===============================
export function get_section(
  page,
  page_size,
  school_id,
  filter_fields,
  class_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}section/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}
export function add_section(data, school_id, token, signal) {
  const apiUrl = `${API_URL}section/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_section(data, token, signal) {
  const apiUrl = `${API_URL}section/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_section(data, token, signal) {
  const apiUrl = `${API_URL}section/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_section_list(school_id, class_id, token, signal) {
  let apiUrl = `${API_URL}section-list/?`;
  const params = [];

  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);

  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}
//   =======================get role ===============================
export function get_role(page, page_size, token, school_id, signal) {
  let apiUrl = `${API_URL}role/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_role(data, token, school_id, signal) {
  let apiUrl = `${API_URL}role/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_role(data, token, school_id, signal) {
  let apiUrl = `${API_URL}role/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_role(data, token, school_id, signal) {
  let apiUrl = `${API_URL}role/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_role_list(token, school_id, signal) {
  let apiUrl = `${API_URL}role-list/?`;
  const params = [];

  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

//   =======================Users ===============================
export function get_user(page, page_size, school_id, role, token, signal) {
  const apiUrl = `${API_URL}users/?page=${page}&page_size=${page_size}&school_id=${school_id}&role=${role}`;
  return fetchData(apiUrl, token, signal);
}
export function add_user(data, role, token, signal) {
  const apiUrl = `${API_URL}users/?role=${role}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_user(data, token, signal) {
  const apiUrl = `${API_URL}users/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_user(data, token, signal) {
  const apiUrl = `${API_URL}users/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_user_list(token, signal) {
  const apiUrl = `${API_URL}users-list/`;
  return fetchData(apiUrl, token, signal);
}

//   =======================get Session ===============================
export function get_session(page, page_size, school_id, token, signal) {
  const apiUrl = `${API_URL}session/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_session(data, school_id, token, signal) {
  const apiUrl = `${API_URL}session/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_session(data, token, signal) {
  const apiUrl = `${API_URL}session/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_session(data, token, signal) {
  const apiUrl = `${API_URL}session/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_session_list(school_id, token, signal) {
  const apiUrl = `${API_URL}session-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================get department ===============================
export function get_department(page, page_size, school_id, token, signal) {
  const apiUrl = `${API_URL}department/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_department(data, school_id, token, signal) {
  const apiUrl = `${API_URL}department/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_department(data, token, signal) {
  const apiUrl = `${API_URL}department/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_department(data, token, signal) {
  const apiUrl = `${API_URL}department/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_department_list(school_id, token, signal) {
  const apiUrl = `${API_URL}department-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}

//   =======================get designations ===============================
export function get_designation(
  page,
  page_size,
  school_id,
  department_id,
  token,
  signal
) {
  const apiUrl = `${API_URL}designation/?page=${page}&page_size=${page_size}&school_id=${school_id}&department_id=${department_id}`;
  return fetchData(apiUrl, token, signal);
}

export function add_designation(data, school_id, token, signal) {
  const apiUrl = `${API_URL}designation/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_designation(data, token, signal) {
  const apiUrl = `${API_URL}designation/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_designation(data, token, signal) {
  const apiUrl = `${API_URL}designation/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_designation_list(school_id, department_id, token, signal) {
  const apiUrl = `${API_URL}designation-list/?school_id=${school_id}&department_id=${department_id}`;
  return fetchData(apiUrl, token, signal);
}

//   =======================House ===============================
export function get_house(page, page_size, school_id, token, signal) {
  const apiUrl = `${API_URL}house/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_house(data, school_id, token, signal) {
  const apiUrl = `${API_URL}house/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_house(data, token, school_id, signal) {
  let apiUrl = `${API_URL}house/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_house(data, token, school_id, signal) {
  let apiUrl = `${API_URL}house/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_house_list(school_id, token, signal) {
  const apiUrl = `${API_URL}house-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
//  ======================School=================
export function get_school(
  page,
  page_size,
  school_id,
  department_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}school/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (department_id) params.push(`department_id=${department_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function update_school_by_own(data, token, signal) {
  const apiUrl = `${API_URL}school/`;
  return patchData(apiUrl, data, token, signal);
}
export function add_school(data, school_id, token, signal) {
  const apiUrl = `${API_URL}school/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_school(data, token, signal) {
  const apiUrl = `${API_URL}school/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_school(data, token, signal) {
  const apiUrl = `${API_URL}school/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_school_list(token, signal) {
  const apiUrl = `${API_URL}school-list/?`;
  return fetchData(apiUrl, token, signal);
}
//  ======================teacher=================
export function get_teacher(
  page,
  page_size,
  school_id,
  filter_fields,
  department_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}teacher/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (department_id) params.push(`department_id=${department_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_teacher(data, school_id, token, signal) {
  const apiUrl = `${API_URL}teacher/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_teacher(data, token, school_id, signal) {
  let apiUrl = `${API_URL}teacher/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_teacher(data, token, school_id, signal) {
  let apiUrl = `${API_URL}teacher/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_teacher_list(school_id, department_id, token, signal) {
  let apiUrl = `${API_URL}teacher-list/?`;
  if (school_id) {
    apiUrl += `school_id=${school_id}&`;
  }
  if (department_id) {
    apiUrl += `department_id=${department_id}&`;
  }
  apiUrl =
    apiUrl.endsWith("&") || apiUrl.endsWith("?") ? apiUrl.slice(0, -1) : apiUrl;
  return fetchData(apiUrl, token, signal);
}
export function get_class_teacher_list(
  school_id,
  class_id,
  department_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}class-teacher-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (department_id) params.push(`department_id=${department_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function update_class_section_teacher(data, school_id, token, signal) {
  const apiUrl = `${API_URL}assign-class-teacher/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
//   =======================subject ===============================
export function get_subject(
  page,
  page_size,
  school_id,
  filter_fields,
  class_id,
  token,
  signal
) {
  // const apiUrl = `${API_URL}subject/?page=${page}&page_size=${page_size}&school_id=${school_id}&class_id=${class_id}`;
  let apiUrl = `${API_URL}subject/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  if (class_id) params.push(`class_id=${class_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_subject(data, school_id, token, signal) {
  const apiUrl = `${API_URL}subject/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_subject(data, token, signal) {
  const apiUrl = `${API_URL}subject/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_subject(data, token, signal) {
  const apiUrl = `${API_URL}subject/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_subject_list(school_id, class_id, token, signal) {
  const apiUrl = `${API_URL}subject-list/?school_id=${school_id}&class_id=${class_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================get Session ===============================
export function get_leave(page, page_size, school_id, type, token, signal) {
  const apiUrl = `${API_URL}leave/?page=${page}&page_size=${page_size}&school_id=${school_id}&type=${type}`;
  return fetchData(apiUrl, token, signal);
}
export function add_leave(data, school_id, token, signal) {
  const apiUrl = `${API_URL}leave/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_leave(data, token, signal) {
  const apiUrl = `${API_URL}leave/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_leave(data, token, signal) {
  const apiUrl = `${API_URL}leave/`;
  return deletData(apiUrl, data, token, signal);
}
//   =======================get timetable ===============================
export function get_timetable(school_id, class_id, section_id, token, signal) {
  let apiUrl = `${API_URL}newtimetable/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_timetable(data, school_id, token, signal) {
  const apiUrl = `${API_URL}timetable/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_timetable(data, token, signal) {
  const apiUrl = `${API_URL}timetable/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_timetable(data, token, signal) {
  const apiUrl = `${API_URL}timetable/`;
  return deletData(apiUrl, data, token, signal);
}

//   =======================attendence ===============================
export function get_attendance_student_list(
  school_id,
  class_id,
  section_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}attendance-student-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_attendance_register(
  month,
  year,
  class_id,
  section_id,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}attendance-mark/?`;
  const params = [];
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (month) params.push(`month=${month}`);
  if (year) params.push(`year=${year}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_attendence(
  page,
  page_size,
  school_id,
  date,
  class_id,
  section_id,
  student_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}attendance/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (date) params.push(`date=${date}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  if (student_id) params.push(`student_id=${student_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function mark_attendence(
  data,
  date,
  class_id,
  section_id,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}attendance-mark/?`;
  const params = [];
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (date) params.push(`date=${date}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function get_attendence_register(
  school_id,
  month,
  year,
  class_id,
  section_id,
  student_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}attendance-register/?`;
  const params = [];
  if (month) params.push(`month=${month}`);
  if (year) params.push(`year=${year}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  if (student_id) params.push(`student_id=${student_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_attendence(data, school_id, token, signal) {
  const apiUrl = `${API_URL}attendance/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_attendence(data, token, signal) {
  const apiUrl = `${API_URL}attendance/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_attendence(data, token, signal) {
  const apiUrl = `${API_URL}attendance/`;
  return deletData(apiUrl, data, token, signal);
}
//   =======================get noticeboard ===============================
export function get_notice(page, page_size, school_id, token, signal) {
  const apiUrl = `${API_URL}notice/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_notice(data, school_id, token, signal) {
  const apiUrl = `${API_URL}notice/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_notice(data, token, signal) {
  const apiUrl = `${API_URL}notice/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_notice(data, token, signal) {
  const apiUrl = `${API_URL}notice/`;
  return deletData(apiUrl, data, token, signal);
}
// ======================================report generate using sql query===========
export function generate_report(data, token, signal) {
  const apiUrl = `${API_URL}generate-report/`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function get_db_model(token, signal) {
  const apiUrl = `${API_URL}generate-report/`;
  return fetchData(apiUrl, token, signal);
}
export function get_table_column(table_name, token, signal) {
  const apiUrl = `${API_URL}table-column/?table_name=${table_name}`;
  return fetchData(apiUrl, token, signal);
}
export function bulk_upload(data, token, signal) {
  const apiUrl = `${API_URL}bulk-upload/`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

//   =======================get student ===============================
export function get_student(
  page,
  page_size,
  school_id,
  search,
  filter_fields,
  token,
  signal
) {
  // const apiUrl = `${API_URL}student/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  let apiUrl = `${API_URL}student/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_bulk_student(
  school_id,
  club_id,
  class_id,
  session_id,
  section_id,
  dormitory_id,
  dormitoryroom_id,
  category,
  house_id,
  student_category_id,
  search,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-bulk/?`;
  const params = [];
  if (search) params.push(`search=${search}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (club_id) params.push(`club_id=${club_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (session_id) params.push(`session_id=${session_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  if (dormitory_id) params.push(`dormitory_id=${dormitory_id}`);
  if (dormitoryroom_id) params.push(`dormitoryroom_id=${dormitoryroom_id}`);
  if (category) params.push(`category=${category}`);
  if (house_id) params.push(`house_id=${house_id}`);
  if (student_category_id)
    params.push(`student_category_id=${student_category_id}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}
export function add_student(data, school_id, token, signal) {
  const apiUrl = `${API_URL}student/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_student(data, token, school_id, signal) {
  let apiUrl = `${API_URL}student/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_student(data, token, signal) {
  const apiUrl = `${API_URL}student/`;
  return deletData(apiUrl, data, token, signal);
}
export function bulk_update_student(data, token, signal) {
  const apiUrl = `${API_URL}student/`;
  return patchData(apiUrl, data, token, signal);
}

export function get_student_list(
  school_id,
  class_id,
  section_id,
  token,
  search,
  signal
) {
  let apiUrl = `${API_URL}student-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ===============================section and roll no  assign============
export function update_student_section_rollno(data, school_id, token, signal) {
  const apiUrl = `${API_URL}roll-section-assign/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

//   =======================get parent ===============================
export function get_parent(
  page,
  page_size,
  school_id,
  student_id,
  token,
  signal
) {
  const apiUrl = `${API_URL}parent/?page=${page}&page_size=${page_size}&school_id=${school_id}&student_id=${student_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_parent(data, school_id, token, signal) {
  const apiUrl = `${API_URL}parent/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_parent(data, token, signal) {
  const apiUrl = `${API_URL}parent/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_parent(data, token, signal) {
  const apiUrl = `${API_URL}parent/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_parent_list(school_id, student_id, token, signal) {
  const apiUrl = `${API_URL}parent-list/?school_id=${school_id}&student_id=${student_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================get student category ===============================
export function get_student_category(
  page,
  page_size,
  filter_fields,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-category/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_student_category(data, school_id, token, signal) {
  const apiUrl = `${API_URL}student-category/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_student_category(data, token, signal) {
  const apiUrl = `${API_URL}student-category/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_student_category(data, token, signal) {
  const apiUrl = `${API_URL}student-category/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_student_category_list(
  school_id,
  filter_fields,
  token,
  signal
) {
  const apiUrl = `${API_URL}student-category-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================Club ===============================

export function get_club(
  page,
  page_size,
  filter_fields,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}club/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_club(data, school_id, token, signal) {
  const apiUrl = `${API_URL}club/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_club(data, token, signal) {
  const apiUrl = `${API_URL}club/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_club(data, token, signal) {
  const apiUrl = `${API_URL}club/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_club_list(school_id, token, signal) {
  const apiUrl = `${API_URL}club-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================Hostel Rooom ===============================
export function get_hostel_room(page, page_size, school_id, token, signal) {
  const apiUrl = `${API_URL}hostel-room/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_hostel_room(data, school_id, token, signal) {
  const apiUrl = `${API_URL}hostel-room/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_hostel_room(data, token, signal) {
  const apiUrl = `${API_URL}hostel-room/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_hostel_room(data, token, signal) {
  const apiUrl = `${API_URL}hostel-room/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_hostel_room_list(school_id, token, signal) {
  const apiUrl = `${API_URL}hostel-room-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================Hostel category ===============================
export function get_hostel_category(page, page_size, school_id, token, signal) {
  const apiUrl = `${API_URL}hostel-category/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_hostel_category(data, school_id, token, signal) {
  const apiUrl = `${API_URL}hostel-category/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_hostel_category(data, token, signal) {
  const apiUrl = `${API_URL}hostel-category/`;
  return putData(apiUrl, data, token, signal);
}

export function delete_hostel_category(data, token, signal) {
  const apiUrl = `${API_URL}hostel-category/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_hostel_category_list(school_id, token, signal) {
  const apiUrl = `${API_URL}hostel-category-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================Dormitory ===============================
export function get_dormitory(page, page_size, school_id, token, signal) {
  const apiUrl = `${API_URL}dormitory/?page=${page}&page_size=${page_size}&school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_dormitory(data, school_id, token, signal) {
  const apiUrl = `${API_URL}dormitory/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_dormitory(data, token, signal) {
  const apiUrl = `${API_URL}dormitory/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_dormitory(data, token, signal) {
  const apiUrl = `${API_URL}dormitory/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_dormitory_list(school_id, token, signal) {
  const apiUrl = `${API_URL}dormitory-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================Dormitory Rooom ===============================
export function get_dormitoryroom(
  page,
  page_size,
  school_id,
  dormitory_id,
  token,
  signal
) {
  const apiUrl = `${API_URL}dormitory-room/?page=${page}&page_size=${page_size}&school_id=${school_id}&dormitory_id=${dormitory_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_dormitoryroom(data, school_id, token, signal) {
  const apiUrl = `${API_URL}dormitory-room/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_dormitoryroom(data, token, signal) {
  const apiUrl = `${API_URL}dormitory-room/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_dormitoryroom(data, token, signal) {
  const apiUrl = `${API_URL}dormitory-room/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_dormitoryroom_list(school_id, dormitory_id, token, signal) {
  const apiUrl = `${API_URL}dormitory-room-list/?school_id=${school_id}&dormitory_id=${dormitory_id}`;
  return fetchData(apiUrl, token, signal);
}
//   =======================get syllabus===============================
export function get_syllabus(
  page,
  page_size,
  school_id,
  subject_id,
  token,
  signal
) {
  const apiUrl = `${API_URL}syllabus/?page=${page}&page_size=${page_size}&school_id=${school_id}&subject_id=${subject_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_syllabus(data, school_id, token, signal) {
  const apiUrl = `${API_URL}syllabus/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_syllabus(data, token, signal) {
  const apiUrl = `${API_URL}syllabus/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_syllabus(data, token, signal) {
  const apiUrl = `${API_URL}syllabus/`;
  return deletData(apiUrl, data, token, signal);
}
//=======================feedback===============================
export function get_feedback(
  page,
  page_size,
  school_id,
  class_id,
  student_id,
  token,
  signal
) {
  const apiUrl = `${API_URL}feedback/?page=${page}&page_size=${page_size}&school_id=${school_id}&student_id=${student_id}&class_id=${class_id}`;
  return fetchData(apiUrl, token, signal);
}
export function add_feedback(data, school_id, token, signal) {
  const apiUrl = `${API_URL}feedback/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_feedback(data, token, signal) {
  const apiUrl = `${API_URL}feedback/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_feedback(data, token, signal) {
  const apiUrl = `${API_URL}feedback/`;
  return deletData(apiUrl, data, token, signal);
}
// ============================event=======================
export function get_event(
  page,
  page_size,
  school_id,
  month,
  year,
  token,
  signal
) {
  const apiUrl = `${API_URL}event/?page=${page}&page_size=${page_size}&school_id=${school_id}&month=${month}&year=${year}`;
  return fetchData(apiUrl, token, signal);
}
export function add_event(data, school_id, token, signal) {
  const apiUrl = `${API_URL}event/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_event(data, token, signal) {
  const apiUrl = `${API_URL}event/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_event(data, token, signal) {
  const apiUrl = `${API_URL}event/`;
  return deletData(apiUrl, data, token, signal);
}
// =======================dashboard========================

export function student_gender_caste_religion(token, school_id, signal) {
  const apiUrl = `${API_URL}student-gender-other/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}

export function get_dash_event(month, year, token, signal) {
  const apiUrl = `${API_URL}dashboard-event/?month=${month}&year=${year}`;
  return fetchData(apiUrl, token, signal);
}
// ================================Coactivitye======================================
export function get_coactivity(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-activity/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_coactivity(data, school_id, token, signal) {
  const apiUrl = `${API_URL}exam-activity/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_coactivity(data, token, signal) {
  const apiUrl = `${API_URL}exam-activity/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_coactivity(data, token, signal) {
  const apiUrl = `${API_URL}exam-activity/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_coactivity_list(school_id, token, signal) {
  const apiUrl = `${API_URL}exam-activity-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
// ================================exam type======================================
export function get_examtype(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-type/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_examtype(data, school_id, token, signal) {
  const apiUrl = `${API_URL}exam-type/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_examtype(data, token, signal) {
  const apiUrl = `${API_URL}exam-type/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_examtype(data, token, signal) {
  const apiUrl = `${API_URL}exam-type/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_examtype_list(school_id, token, signal) {
  const apiUrl = `${API_URL}exam-type-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
// ================================exam grade======================================
export function get_examgrade(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-grade/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_examgrade(data, school_id, token, signal) {
  const apiUrl = `${API_URL}exam-grade/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_examgrade(data, token, signal) {
  const apiUrl = `${API_URL}exam-grade/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_examgrade(data, token, signal) {
  const apiUrl = `${API_URL}exam-grade/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_examgrade_list(school_id, token, signal) {
  let apiUrl = `${API_URL}exam-grade-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================exam======================================
export function get_exam(page, page_size, school_id, search, token, signal) {
  let apiUrl = `${API_URL}exam/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_exam_id(exam_id, token, signal) {
  let apiUrl = `${API_URL}exam/?`;
  const params = [];
  if (exam_id) params.push(`exam_id=${exam_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_exam(data, school_id, token, signal) {
  const apiUrl = `${API_URL}exam/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_exam(data, school_id, token, signal) {
  let apiUrl = `${API_URL}exam/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_exam(data, school_id, token, signal) {
  let apiUrl = `${API_URL}exam/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_examlist(
  school_id,
  session,
  school_class,
  section,
  token,
  signal
) {
  let apiUrl = `${API_URL}exam-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (session) params.push(`session=${session}`);
  if (school_class) params.push(`school_class=${school_class}`);
  if (section) params.push(`section=${section}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================admit card======================================
export function get_admitcard(exam, session, school_id, token, signal) {
  let apiUrl = `${API_URL}admit-card/?`;
  const params = [];
  if (exam) params.push(`exam=${exam}`);
  if (session) params.push(`session=${session}`);

  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_admitcard(data, school_id, token, signal) {
  const apiUrl = `${API_URL}admit-card/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_admitcard(data, token, signal) {
  const apiUrl = `${API_URL}admit-card/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_admitcard(data, token, signal) {
  const apiUrl = `${API_URL}admit-card/`;
  return deletData(apiUrl, data, token, signal);
}

export function get_admit_card_html(id, school_id, token, signal) {
  let apiUrl = `${API_URL}admit-card-html/?`;
  const params = [];
  if (id) params.push(`id=${id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================Result======================================
export function get_examresult(
  school_id,
  exam,
  school_class,
  section,
  session,
  student_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}exam-result/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (exam) params.push(`exam=${exam}`);
  if (school_class) params.push(`school_class=${school_class}`);
  if (section) params.push(`section=${section}`);
  if (session) params.push(`session=${session}`);
  if (student_id) params.push(`student_id=${student_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_examresult(data, school_id, token, signal) {
  const apiUrl = `${API_URL}exam-result/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_examresult(data, school_id, token, signal) {
  const apiUrl = `${API_URL}exam-result/?school_id=${school_id}`;
  return putData(apiUrl, data, token, signal);
}
export function delete_examresult(data, token, signal) {
  const apiUrl = `${API_URL}exam-result/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_exam_result_html(exam, student, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-result-html/?`;
  const params = [];
  if (exam) params.push(`exam=${exam}`);
  if (student) params.push(`student=${student}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================Result======================================
export function get_payroll(
  page,
  page_size,
  school_id,
  date,
  month,
  user,
  token,
  signal
) {
  let apiUrl = `${API_URL}payroll/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (date) params.push(`date=${date}`);
  if (month) params.push(`month=${month}`);
  if (user) params.push(`user=${user}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_payroll(data, school_id, token, signal) {
  const apiUrl = `${API_URL}payroll/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_payroll(data, token, signal) {
  const apiUrl = `${API_URL}payroll/`;
  return putData(apiUrl, data, token, signal);
}

export function delete_payroll(data, token, signal) {
  const apiUrl = `${API_URL}payroll/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_payroll_salary(id, token, signal) {
  let apiUrl = `${API_URL}user-salary/?`;
  const params = [];
  if (id) params.push(`id=${id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================shool gallery======================================
export function get_gallery(page, page_size, type, school_id, token, signal) {
  let apiUrl = `${API_URL}gallery/categories/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (type) params.push(`type=${type}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_gallery(data, school_id, token, signal) {
  const apiUrl = `${API_URL}gallery/categories/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_gallery(data, token, signal) {
  const apiUrl = `${API_URL}gallery/categories/`;
  return putData(apiUrl, data, token, signal);
}

export function delete_gallery(data, token, signal) {
  const apiUrl = `${API_URL}gallery/categories/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_gallery_photo(category, type, token, signal) {
  const apiUrl = `${API_URL}gallery/images/${category}/?type=${type}`;
  return fetchData(apiUrl, token, signal);
}
// ================================Promotion======================================
export function get_promotion(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}promotion/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_promotion(data, school_id, token, signal) {
  const apiUrl = `${API_URL}promotion/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_promotion(data, token, signal) {
  const apiUrl = `${API_URL}promotion/`;
  return putData(apiUrl, data, token, signal);
}

export function delete_promotion(data, token, signal) {
  const apiUrl = `${API_URL}promotion/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_promotion_student(
  class_id,
  section_id,
  session_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}promotion-student/?`;
  const params = [];
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  if (session_id) params.push(`session_id=${session_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ============================================Fee categery new =======================================================
// export function get_feecategory(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}fee-category-new/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function add_feecategory(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}fee-category-new/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// export function update_feecategory(data, token, signal) {
//   const apiUrl = `${API_URL}fee-category-new/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_feecategory(data, token, signal) {
//   const apiUrl = `${API_URL}fee-category-new/`;
//   return deletData(apiUrl, data, token, signal);
// }

// ================================================fee plain new ================================
// export function get_feeplan_detail(feeplan_id,student_id, token, signal) {
//   let apiUrl = `${API_URL}student-fee-details/?`;
//   const params = [];
//   if (feeplan_id) params.push(`feeplan_id=${feeplan_id}`);
//   if (student_id) params.push(`student_id=${student_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function get_feeplan(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}fee-plan/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function add_feeplan(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}fee-plan/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// export function update_feeplan(data, token, signal) {
//   const apiUrl = `${API_URL}fee-plan/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_feeplan(data, token, signal) {
//   const apiUrl = `${API_URL}fee-plan/`;
//   return deletData(apiUrl, data, token, signal);
// }

// export function get_feeplanlist(school_id,token, signal) {
//   let apiUrl = `${API_URL}fee-plan-list/?`;
//   const params = [];
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// ================================= Transport fee plan new ===============================

// export function get_transportfeeplan(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}transport-plan/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function add_transportfeeplan(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}transport-plan/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// export function update_transportfeeplan(data, token, signal) {
//   const apiUrl = `${API_URL}transport-plan/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_transportfeeplan(data, token, signal) {
//   const apiUrl = `${API_URL}transport-plan/`;
//   return deletData(apiUrl, data, token, signal);
// }

// ======================================Student  Fee wallet =====================================

// export function get_student_wallet(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}wallet/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function get_student_wallet_by_id(id, token, signal) {
//   const apiUrl = `${API_URL}wallet/?student_id=${id}`;
//   return fetchData(apiUrl, token, signal);
// }

// export function update_student_wallet(data, token, signal) {
//   const apiUrl = `${API_URL}wallet/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_student_wallet(data, token, signal) {
//   const apiUrl = `${API_URL}wallet/`;
//   return deletData(apiUrl, data, token, signal);
// }

// ================================================student fee details new ================================

// export function get_student_fee_details(student_id, school_id,token,signal) {
//   let apiUrl = `${API_URL}student-fee-details/?student_id=${student_id}`;
//   const params = [];
//   if (school_id) params.push(`student_id=${student_id}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// ================================================Student fee discount new =================================

// export function get_student_fee_discount(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}discount/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function add_student_fee_discount(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}discount/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// export function update_student_fee_discount(data, token, signal) {
//   const apiUrl = `${API_URL}discount/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_student_fee_discount(data, token, signal) {
//   const apiUrl = `${API_URL}discount/`;
//   return deletData(apiUrl, data, token, signal);
// }
// export function get_student_fee_discountlist(school_id,token, signal) {
//   let apiUrl = `${API_URL}discount-list/?`;
//   const params = [];
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// ================================================Student Term Record new =================================

// export function get_student_term_record(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}term-record/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function update_student_term_record(data, token, signal) {
//   const apiUrl = `${API_URL}term-record/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_student_term_record(data, token, signal) {
//   const apiUrl = `${API_URL}term-record/`;
//   return deletData(apiUrl, data, token, signal);
// }

// ================================================Student Fee Payment new =================================

//  export function get_student_payment(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}payment/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function add_student_payment(data,student_id, school_id, token, signal) {
//   let apiUrl = `${API_URL}payment/`;
//   const params = [];
//   // if (student_id) params.push(`student_id=${student_id}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// ====================================STudent transportwallet ================================

// export function get_student_transport_wallet(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}transport-wallet/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function get_student_Transportfee_wallet_by_id(student_id, token, signal) {
//   const apiUrl = `${API_URL}transport-wallet/?student_id=${student_id}`;
//   return fetchData(apiUrl, token, signal);
// }

// ================================StudentFeedetails ============================

// export function get_student_feedetails( student_id, token, signal) {
//   let apiUrl = `${API_URL}student-fee-details/?`;
//   const params = [];
//   if (student_id) params.push(`student_id=${student_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// ================================Fee Category======================================
// export function get_feecategory(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}fee-category/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function add_feecategory(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}fee-category/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// export function get_student_fee_discount(data, token, signal) {
//   const apiUrl = `${API_URL}fee-category/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_feecategory(data, token, signal) {
//   const apiUrl = `${API_URL}fee-category/`;
//   return deletData(apiUrl, data, token, signal);
// }
// export function get_feecategory_list(school_id, token, signal) {
//   let apiUrl = `${API_URL}fee-category-list/?`;
//   const params = [];
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }
// ================================Fee Discount======================================
export function get_fee_receipt(
  page,
  page_size,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}pay-receipt/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================bank account======================================
export function get_bank_trans(
  page,
  page_size,
  search,
  user,
  filter_fields,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}bank-trans/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (user) params.push(`user=${user}`);

  if (search) params.push(`search=${search}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}

export function get_bankaccount(
  page,
  page_size,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}bank-account/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_bankaccount(data, school_id, token, signal) {
  const apiUrl = `${API_URL}bank-account/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_bankaccount(data, token, signal) {
  const apiUrl = `${API_URL}bank-account/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_bankaccount(data, token, signal) {
  const apiUrl = `${API_URL}bank-account/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_bankaccount_list(school_id, token, signal) {
  let apiUrl = `${API_URL}bank-account-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================Employee attendance record======================================

export function get_emp_attendance(
  page,
  page_size,
  search,
  school_id,
  formdata,
  token,
  signal
) {
  let apiUrl = `${API_URL}emp-attendance/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (search) params.push(`search=${search}`);
  if (school_id) params.push(`school_id=${school_id}`);
  for (const key in formdata) {
    const value = formdata[key];

    // Include value if it's not undefined or null
    if (value !== undefined && value !== null && value !== "") {
      params.push(`${key}=${value}`);
    }
  }
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_emp_attendance(data, school_id, token, signal) {
  const apiUrl = `${API_URL}emp-attendance/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_emp_attendance(data, token, school_id, signal) {
  const apiUrl = `${API_URL}emp-attendance/?school_id=${school_id}`;
  return putData(apiUrl, data, token, signal);
}
export function delete_emp_attendance(data, token, school_id, signal) {
  const apiUrl = `${API_URL}emp-attendance/?school_id=${school_id}`;
  return deletData(apiUrl, data, token, signal);
}

// ================================Employee attendance record======================================

export function get_stafftask(
  page,
  page_size,
  search,
  school_id,
  formdata,
  token,
  signal
) {
  let apiUrl = `${API_URL}staff-task/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (search) params.push(`search=${search}`);
  if (school_id) params.push(`school_id=${school_id}`);
  for (const key in formdata) {
    const value = formdata[key];

    // Include value if it's not undefined or null
    if (value !== undefined && value !== null && value !== "") {
      params.push(`${key}=${value}`);
    }
  }
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_stafftask(data, school_id, token, signal) {
  const apiUrl = `${API_URL}staff-task/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_stafftask(data, token, school_id, signal) {
  const apiUrl = `${API_URL}staff-task/?school_id=${school_id}`;
  return putData(apiUrl, data, token, signal);
}
export function delete_stafftask(data, token, school_id, signal) {
  const apiUrl = `${API_URL}staff-task/?school_id=${school_id}`;
  return deletData(apiUrl, data, token, signal);
}
//====================================report config===================================
export function get_reportconfig(
  page,
  page_size,
  school_id,
  report_key,
  token,
  signal
) {
  let apiUrl = `${API_URL}report-config/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (report_key) params.push(`report_key=${report_key}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_reportconfig(data, school_id, token, signal) {
  const apiUrl = `${API_URL}report-config/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_reportconfig(data, token, school_id, signal) {
  let apiUrl = `${API_URL}report-config/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_reportconfig(data, token, school_id, signal) {
  let apiUrl = `${API_URL}report-config/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_reportconfig_list(school_id, token, signal) {
  let apiUrl = `${API_URL}report-config-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_eduu_reportconfig(id, school_id, token, signal) {
  let apiUrl = `${API_URL}eduux-report/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (id) params.push(`id=${id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_eduu_reportcategory(school_id, token, signal) {
  let apiUrl = `${API_URL}report-category-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_studentreport_genrate(
  page,
  page_size,
  school_id,
  formdata,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-report/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  for (const key in formdata) {
    const value = formdata[key];

    // Include value if it's not undefined or null
    if (value !== undefined && value !== null && value !== "") {
      params.push(`${key}=${value}`);
    }
  }

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_student_id_car_cert(
  school_id,
  formdata,
  user_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-id-qr/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (user_id) params.push(`user_id=${user_id}`);
  for (const key in formdata) {
    const value = formdata[key];

    // Include value if it's not undefined or null
    if (value !== undefined && value !== null && value !== "") {
      params.push(`${key}=${value}`);
    }
  }
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_student_id_card_list(
  search,
  school_class,
  section,
  session,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-id-list/?`;
  const params = [];
  if (search) params.push(`search=${search}`);
  if (school_class) params.push(`school_class=${school_class}`);
  if (section) params.push(`section=${section}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (session) params.push(`session=${session}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_user_id_car_cert(
  school_id,
  formdata,
  user_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}user-id-qr/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (user_id) params.push(`user_id=${user_id}`);
  for (const key in formdata) {
    const value = formdata[key];

    // Include value if it's not undefined or null
    if (value !== undefined && value !== null && value !== "") {
      params.push(`${key}=${value}`);
    }
  }
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_user_id_card_list(search, role, school_id, token, signal) {
  let apiUrl = `${API_URL}user-id-list/?`;
  const params = [];
  if (search) params.push(`search=${search}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (role) params.push(`role=${role}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

//====================================certificate template===================================
export function get_certitemplate(
  page,
  page_size,
  school_id,
  report_key,
  token,
  signal
) {
  let apiUrl = `${API_URL}certi-template/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (report_key) params.push(`report_key=${report_key}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_certitemplate(data, school_id, token, signal) {
  const apiUrl = `${API_URL}certi-template/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_certitemplate(data, token, school_id, signal) {
  let apiUrl = `${API_URL}certi-template/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_certitemplate(data, token, school_id, signal) {
  let apiUrl = `${API_URL}certi-template/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_certitemplate_list(school_id, report_type, token, signal) {
  let apiUrl = `${API_URL}certi-template-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (report_type) params.push(`report_type=${report_type}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================Fee Discount======================================
export function get_feediscount(
  page,
  page_size,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}discounts/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_feediscount(data, school_id, token, signal) {
  const apiUrl = `${API_URL}discounts/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_feediscount(data, token, signal) {
  const apiUrl = `${API_URL}discounts/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_feediscount(data, token, signal) {
  const apiUrl = `${API_URL}discounts/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_feediscount_list(school_id, token, signal) {
  let apiUrl = `${API_URL}discounts-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================student discount apply======================================
export function get_apply_discount(
  page,
  page_size,
  student_id,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}apply-discount/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (student_id) params.push(`student_id=${student_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_apply_discount(data, school_id, token, signal) {
  const apiUrl = `${API_URL}apply-discount/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function delete_apply_discount(data, token, signal) {
  const apiUrl = `${API_URL}apply-discount/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================Fee package======================================

export function delete_student_fee_detail(id, token, signal) {
  const apiUrl = `${API_URL}fee-package-detail/${id}/`;
  return deletData(apiUrl, "", token, signal);
}
export function update_student_fee_detail(id, data, token, signal) {
  const apiUrl = `${API_URL}fee-package-detail/${id}/`;
  return putData(apiUrl, data, token, signal);
}
// ================================reset feepackage======================================

export function reset_fee_package(id, token, signal) {
  const apiUrl = `${API_URL}reset-fee-package/${id}/`;
  return PostwithotDatawithToken(apiUrl, token, signal);
}
// ================================Other Onvoice======================================
export function get_other_invoice(
  page,
  page_size,
  user_id,
  search,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}other-invoice/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);
  if (user_id) params.push(`user_id=${user_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_other_invoice(data, school_id, token, signal) {
  const apiUrl = `${API_URL}other-invoice/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_other_invoice(data, token, signal) {
  const apiUrl = `${API_URL}other-invoice/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_other_invoice(data, token, signal) {
  const apiUrl = `${API_URL}other-invoice/`;
  return deletData(apiUrl, data, token, signal);
}

export function get_invoice_receipt_html(id, school_id, token, signal) {
  let apiUrl = `${API_URL}other-invoice-html/?`;
  const params = [];
  if (id) params.push(`id=${id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}

export function get_test_admit_receipt_html(type, school_id, token, signal) {
  let apiUrl = `${API_URL}test-admit-result/?`;
  const params = [];
  if (type) params.push(`type=${type}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================Fee package======================================
export function get_feepackage(
  page,
  page_size,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}fee-package/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_feepackage(data, school_id, token, signal) {
  const apiUrl = `${API_URL}fee-package/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_feepackage(data, token, signal) {
  const apiUrl = `${API_URL}fee-package/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_feepackage(data, token, signal) {
  const apiUrl = `${API_URL}fee-package/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_feepackage_list(
  user_id,
  class_id,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}fee-package-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (user_id) params.push(`user_id=${user_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function bulk_assign_fee_package(data, school_id, token, signal) {
  const apiUrl = `${API_URL}bulk-assign-fee/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function bulk_remove_fee_package(data, school_id, token, signal) {
  const apiUrl = `${API_URL}bulk-assign-fee/?school_id=${school_id}`;
  return deletData(apiUrl, data, token, signal);
}
// ================================Fee Type======================================
export function get_feetype(
  page,
  page_size,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}fee-type/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_feetype(data, school_id, token, signal) {
  const apiUrl = `${API_URL}fee-type/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_feetype(data, token, signal) {
  const apiUrl = `${API_URL}fee-type/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_feetype(data, token, signal) {
  const apiUrl = `${API_URL}fee-type/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_feetype_list(school_id, token, signal) {
  let apiUrl = `${API_URL}fee-type-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================Fee term======================================
export function get_feeterm(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}fee-term/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_feeterm(data, school_id, token, signal) {
  const apiUrl = `${API_URL}fee-term/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_feeterm(data, token, signal) {
  const apiUrl = `${API_URL}fee-term/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_feeterm(data, token, signal) {
  const apiUrl = `${API_URL}fee-term/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_feeterm_list(school_id, token, signal) {
  let apiUrl = `${API_URL}fee-term-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// =========================fee notes=============================
// export function get_feenote(page, page_size, school_id, token, signal) {
//   let apiUrl = `${API_URL}fee-note/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }
// export function add_feenote(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}fee-note/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// export function update_feenote(data, token, signal) {
//   const apiUrl = `${API_URL}fee-note/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_feenote(data, token, signal) {
//   const apiUrl = `${API_URL}fee-note/`;
//   return deletData(apiUrl, data, token, signal);
// }
// ================================Fee Structure======================================
// export function get_feestructure(page, page_size, school_id,student_id,feecategory_id, token, signal) {
//   let apiUrl = `${API_URL}fee-structure/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   if (student_id) params.push(`student_id=${student_id}`);
//   if (feecategory_id) params.push(`feecategory_id=${feecategory_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }
// export function add_feestructure(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}fee-structure/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// export function update_feestructure(data, token, signal) {
//   const apiUrl = `${API_URL}fee-structure/`;
//   return putData(apiUrl, data, token, signal);
// }
// export function delete_feestructure(data, token, signal) {
//   const apiUrl = `${API_URL}fee-structure/`;
//   return deletData(apiUrl, data, token, signal);
// }
// export function get_feestructure_list(school_id,class_id,feecategory_id, token, signal) {
//   let apiUrl = `${API_URL}fee-structure-list/?`;
//   const params = [];
//   if (school_id) params.push(`school_id=${school_id}`);
//   if (class_id) params.push(`class_id=${class_id}`);
//   if (feecategory_id) params.push(`feecategory_id=${feecategory_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }
// ================================Fees Payment======================================
export function get_studentfeeReport(fee_id, token, signal) {
  let apiUrl = `${API_URL}testfee/?`;
  const params = [];
  if (fee_id) params.push(`fee_id=${fee_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// export function pay_fee(data, school_id, token, signal) {
//   const apiUrl = `${API_URL}testfee/?school_id=${school_id}`;
//   return PostDatawithToken(apiUrl, data, token, signal);
// }

// =================================================payment history=====================================

// export function get_paymenthistory(page,page_size,student_id,school_id,token, signal) {
//   let apiUrl = `${API_URL}payment/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   if (student_id) params.push(`student_id=${student_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }
// export function get_receipthistory(page,page_size,student_id,school_id,token, signal) {
//   let apiUrl = `${API_URL}payslip/?`;
//   const params = [];
//   if (page) params.push(`page=${page}`);
//   if (page_size) params.push(`page_size=${page_size}`);
//   if (school_id) params.push(`school_id=${school_id}`);
//   if (student_id) params.push(`student_id=${student_id}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// ================================Fee student======================================
export function get_studentfee(
  page,
  page_size,
  school_id,
  student_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-fee/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (student_id) params.push(`student_id=${student_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_studentfee(data, school_id, token, signal) {
  const apiUrl = `${API_URL}student-fee/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_studentfee(data, token, signal) {
  const apiUrl = `${API_URL}student-fee/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_studentfee(data, token, signal) {
  const apiUrl = `${API_URL}student-fee/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_studentfee_list(
  school_id,
  student_id,
  session_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-fee-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (student_id) params.push(`student_id=${student_id}`);
  if (session_id) params.push(`session_id=${session_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function assignfeediscount(data, school_id, token, signal) {
  let apiUrl = `${API_URL}assign-fee-discount/`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function delete_assignfeediscount(data, token, signal) {
  const apiUrl = `${API_URL}assign-fee-discount/`;
  return deletData(apiUrl, data, token, signal);
}
export function assignfee(data, school_id, token, signal) {
  let apiUrl = `${API_URL}assign-fee/`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function get_assignfee(data, school_id, token, signal) {
  let apiUrl = `${API_URL}assign-fee/`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

// ===============================================AssignStudentFee===================================

export function get_student_fee_package_list(
  search,
  school_class,
  section,
  session,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}Student-list-assign-fee/?`;
  const params = [];
  if (search) params.push(`search=${search}`);
  if (school_class) params.push(`school_class=${school_class}`);
  if (section) params.push(`section=${section}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (session) params.push(`session=${session}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
//   =======================enquiry ===============================
export function get_enquiry(
  page,
  page_size,
  school_id,
  enquiry_type,
  status,
  token,
  signal
) {
  let apiUrl = `${API_URL}enquiry/?`;
  const params = [];
  if (page) params.push(`page=${page}`);

  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (status) params.push(`status=${status}`);
  if (enquiry_type) params.push(`enquiry_type=${enquiry_type}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_enquiry(data, school_id, token, signal) {
  const apiUrl = `${API_URL}enquiry/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_enquiry(data, token, signal) {
  const apiUrl = `${API_URL}enquiry/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_enquiry(data, token, signal) {
  const apiUrl = `${API_URL}enquiry/`;
  return deletData(apiUrl, data, token, signal);
}
//   =======================enquirytype ===============================
export function get_enquirytype(
  page,
  page_size,
  school_id,
  status,
  token,
  signal
) {
  let apiUrl = `${API_URL}enquiry-type/?page=${page}&`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (status) params.push(`status=${status}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_enquirytype(data, school_id, token, signal) {
  const apiUrl = `${API_URL}enquiry-type/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_enquirytype(data, token, signal) {
  const apiUrl = `${API_URL}enquiry-type/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_enquirytype(data, token, signal) {
  const apiUrl = `${API_URL}enquiry-type/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_enquirytype_list(school_id, token, signal) {
  let apiUrl = `${API_URL}enquiry-type-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================earning type======================================
export function get_earningtype(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}earning-type/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_earningtype(data, school_id, token, signal) {
  const apiUrl = `${API_URL}earning-type/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_earningtype(data, token, signal) {
  const apiUrl = `${API_URL}earning-type/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_earningtype(data, token, signal) {
  const apiUrl = `${API_URL}earning-type/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_earningtype_list(school_id, token, signal) {
  const apiUrl = `${API_URL}earning-type-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
// ================================earning add======================================
export function get_earning(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}earning/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_earning(data, school_id, token, signal) {
  const apiUrl = `${API_URL}earning/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_earning(data, token, signal) {
  const apiUrl = `${API_URL}earning/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_earning(data, token, signal) {
  const apiUrl = `${API_URL}earning/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================expense type======================================
export function get_expensetype(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}expense-type/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_expensetype(data, school_id, token, signal) {
  const apiUrl = `${API_URL}expense-type/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_expensetype(data, token, signal) {
  const apiUrl = `${API_URL}expense-type/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_expensetype(data, token, signal) {
  const apiUrl = `${API_URL}expense-type/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_expensetype_list(school_id, token, signal) {
  const apiUrl = `${API_URL}expense-type-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
// ================================expense add======================================
export function get_expense(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}expense/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_expense(data, school_id, token, signal) {
  const apiUrl = `${API_URL}expense/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_expense(data, token, signal) {
  const apiUrl = `${API_URL}expense/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_expense(data, token, signal) {
  const apiUrl = `${API_URL}expense/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================Student Enquiry======================================
export function get_studentenquiry(
  page,
  page_size,
  school_id,
  enquiry_no,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-enquiry/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (enquiry_no) params.push(`enquiry_no=${enquiry_no}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_studentenquiry(data, school_id, token, signal) {
  const apiUrl = `${API_URL}student-enquiry/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_studentenquiry(data, token, signal) {
  const apiUrl = `${API_URL}student-enquiry/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_studentenquiry(data, token, signal) {
  const apiUrl = `${API_URL}student-enquiry/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_studentenquiry_list(school_id, enquiry_no, token, signal) {
  let apiUrl = `${API_URL}student-enquiry-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (enquiry_no) params.push(`enquiry_no=${enquiry_no}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_studentenquiry_by_id(id, token, signal) {
  let apiUrl = `${API_URL}student-enquiry-id/?`;
  const params = [];
  if (id) params.push(`id=${id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================Student registration======================================
export function get_studentregistration(
  page,
  page_size,
  school_id,
  search,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}student-registration/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_studentregistration(data, school_id, token, signal) {
  const apiUrl = `${API_URL}student-registration/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_studentregistration(data, token, signal) {
  const apiUrl = `${API_URL}student-registration/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_studentregistration(data, token, signal) {
  const apiUrl = `${API_URL}student-registration/`;
  return deletData(apiUrl, data, token, signal);
}

export function add_studentregistrationtoadmission(
  student_id,
  token,
  school_id,
  signal
) {
  // const apiUrl = `${API_URL}student-registration/?move_to_admission=${true}&student_id=${student_id}`;
  let apiUrl = `${API_URL}student-registration/?move_to_admission=${true}&`;
  const params = [];
  if (student_id) params.push(`student_id=${student_id}`);
  // if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostwithotDatawithToken(apiUrl, token, signal);
}

// ==========================================audit============================
export function get_audit_status(page, page_size, school_id, token, signal) {
  // let apiUrl = `${API_URL}audit/?`;
  let apiUrl = `${API_URL}audit-events/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// =============================================login-status==================================
export function get_login_status(page, page_size, school_id, token, signal) {
  // let apiUrl = `${API_URL}login-audit/?`;
  let apiUrl = `${API_URL}login-audits/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
//====================GRAPH section
export function getMonthlyEarnings(token, school_id, data_type, year, signal) {
  let apiUrl = `${API_URL}total-earnings/?`;
  const params = [];
  if (data_type) params.push(`type=${data_type}`);
  if (year) params.push(`year=${year}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// Function to fetch Leaves data
export function getLeavesData(token, signal) {
  const apiUrl = `${API_URL}leave-count/`;
  return fetchData(apiUrl, token, signal);
}

// Function to fetch Enquiry data
export function getEnquiryData(token, signal) {
  const apiUrl = `${API_URL}enquiry-count/`;
  return fetchData(apiUrl, token, signal);
}

// Function to fetch Departments data
export function getDepartmentsData(token, signal) {
  const apiUrl = `${API_URL}department-count/`;
  return fetchData(apiUrl, token, signal);
}
// Function to fetch Clubs data
export function getClubsData(token, signal) {
  const apiUrl = `${API_URL}club-count/`;
  return fetchData(apiUrl, token, signal);
}

// =========================================get store app ================================
export function get_eduuxpertstore(page, page_size, token, signal) {
  let apiUrl = `${API_URL}stores/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// =========================================class room create ================================

// ================================shool gallery======================================
export function get_classroom(school_id, token, signal) {
  let apiUrl = `${API_URL}classroom/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_classroom(data, school_id, token, signal) {
  const apiUrl = `${API_URL}classroom/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_classroom(data, token, signal) {
  const apiUrl = `${API_URL}classroom/`;
  return putData(apiUrl, data, token, signal);
}

export function delete_classroom(data, token, signal) {
  const apiUrl = `${API_URL}classroom/`;
  return deletData(apiUrl, data, token, signal);
}

// ================================shool gallery======================================
export function get_qrcode(page, page_size, type, school_id, token, signal) {
  let apiUrl = `${API_URL}generate-qr/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (type) params.push(`type=${type}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_qrcode_by_user(user_id, type, school_id, token, signal) {
  let apiUrl = `${API_URL}generate-qr/?`;
  const params = [];
  if (user_id) params.push(`user_id=${user_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (type) params.push(`type=${type}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_qrcode(data, school_id, token, signal) {
  const apiUrl = `${API_URL}generate-qr/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

// export function update_qrcode(data, token, signal) {
//   const apiUrl = `${API_URL}generate-qr/`;
//   return putData(apiUrl, data, token, signal);
// }

export function delete_qrcode(data, token, signal) {
  const apiUrl = `${API_URL}generate-qr/`;
  return deletData(apiUrl, data, token, signal);
}
//====================Meeting=======================
export function get_meeting(page, page_size, type, school_id, token, signal) {
  let apiUrl = `${API_URL}meeting/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (type) params.push(`type=${type}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_meeting(data, school_id, token, signal) {
  const apiUrl = `${API_URL}meeting/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_meeting(data, token, signal) {
  const apiUrl = `${API_URL}meeting/`;
  return putData(apiUrl, data, token, signal);
}
export function add_attendees_meetig(data, token, signal) {
  const apiUrl = `${API_URL}meeting/`;
  return patchData(apiUrl, data, token, signal);
}
export function delete_meeting(data, token, signal) {
  const apiUrl = `${API_URL}meeting/`;
  return deletData(apiUrl, data, token, signal);
}

//====================help support=======================
export function get_helpsupport(
  page,
  page_size,
  type,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}help-support/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_helpsupport(data, school_id, token, signal) {
  const apiUrl = `${API_URL}help-support/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_helpsupport(data, token, signal) {
  const apiUrl = `${API_URL}help-support/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_helpsupport(data, token, signal) {
  const apiUrl = `${API_URL}help-support/`;
  return deletData(apiUrl, data, token, signal);
}
//==============================class room messages=============================
export function get_classroom_messages(page, page_size, token, signal) {
  let apiUrl = `${API_URL}classroom-messages/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_classroom_message(data, token, signal) {
  const apiUrl = `${API_URL}classroom-messages/`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_classroom_message(data, token, signal) {
  const apiUrl = `${API_URL}classroom-messages/`;
  return putData(apiUrl, data, token, signal);
}

export function delete_classroom_message(data, token, signal) {
  const apiUrl = `${API_URL}classroom-messages/`;
  return deletData(apiUrl, data, token, signal);
}

//====================vendor registor=======================
export function get_vendor(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}vendor/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_vendor(data, school_id, token, signal) {
  const apiUrl = `${API_URL}vendor/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_vendor(data, token, signal) {
  const apiUrl = `${API_URL}vendor/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_vendor(data, token, signal) {
  const apiUrl = `${API_URL}vendor/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================product category======================================
export function get_productcategory(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}product-category/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_productcategory(data, school_id, token, signal) {
  const apiUrl = `${API_URL}product-category/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_productcategory(data, token, signal) {
  const apiUrl = `${API_URL}product-category/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_productcategory(data, token, signal) {
  const apiUrl = `${API_URL}product-category/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_productcategory_list(school_id, token, signal) {
  const apiUrl = `${API_URL}product-category-list/?school_id=${school_id}`;
  return fetchData(apiUrl, token, signal);
}
// ================================Product======================================
export function get_product(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}product/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_product(data, school_id, token, signal) {
  const apiUrl = `${API_URL}product/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_product(data, token, signal) {
  const apiUrl = `${API_URL}product/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_product(data, token, signal) {
  const apiUrl = `${API_URL}product/`;
  return deletData(apiUrl, data, token, signal);
}

export function get_product_list(
  page,
  page_size,
  search,
  sort,
  category,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}product-list/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (search) params.push(`search=${search}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (sort) params.push(`sort=${sort}`);
  if (category) params.push(`category=${category}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================Product images======================================
export function get_productspecification(product_id, school_id, token, signal) {
  let apiUrl = `${API_URL}product-specification/?`;
  const params = [];
  if (product_id) params.push(`product_id=${product_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_productspecification(data, school_id, token, signal) {
  const apiUrl = `${API_URL}product-specification/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function delete_productspecification(data, token, signal) {
  const apiUrl = `${API_URL}product-specification/`;
  return deletData(apiUrl, data, token, signal);
}

// ================================Product specification======================================
export function get_productimage(product_id, school_id, token, signal) {
  let apiUrl = `${API_URL}product-images/?`;
  const params = [];
  if (product_id) params.push(`product_id=${product_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_productimage(data, school_id, token, signal) {
  const apiUrl = `${API_URL}product-images/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function delete_productimage(data, token, signal) {
  const apiUrl = `${API_URL}product-images/`;
  return deletData(apiUrl, data, token, signal);
}
// =====================widjhlist=================================
export function add_to_wishlist(product_id, school_id, token, signal) {
  let apiUrl = `${API_URL}wishlist/?`;
  const params = [];
  if (product_id) params.push(`product_id=${product_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, "", token, signal);
}
export function get_wishlist(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}wishlist/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================Notification======================================
export function get_notification(page, page_size, token, signal) {
  let apiUrl = `${API_URL}notification/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  apiUrl += params.join("&");
  console.log("API URL:", apiUrl);

  return fetchData(apiUrl, token, signal);
}
export function add_notification(data, school_id, token, signal) {
  const apiUrl = `${API_URL}product-images/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function delete_notification(data, token, signal) {
  const apiUrl = `${API_URL}product-images/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================google meeting===========================
export function auto_genrate_meeting(data, token, signal) {
  const apiUrl = `${API_URL}google-meeting/`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

// ================================shopping cart===========================

export function get_shopingcart(token, signal) {
  const apiUrl = `${API_URL}cart/?`;
  return fetchData(apiUrl, token, signal);
}
export function add_cart(product_id, school_id, token, signal) {
  let apiUrl = `${API_URL}cart/?`;
  const params = [];
  if (product_id) params.push(`product_id=${product_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, {}, token, signal);
}
export function delete_cart(cartitem_id, school_id, token, signal) {
  let apiUrl = `${API_URL}cart/?`;
  const params = [];
  if (cartitem_id) params.push(`cartitem_id=${cartitem_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, {}, token, signal);
}
// ================================zoom meeting===========================
export function auto_zoom_genrate_meeting(data, token, signal) {
  const apiUrl = `${API_URL}zoom-meeting/`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

// ================================access method======================================
export function get_accessmethod(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}accessmethod/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_accessmethod(data, school_id, token, signal) {
  const apiUrl = `${API_URL}accessmethod/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_accessmethod(data, token, signal) {
  const apiUrl = `${API_URL}accessmethod/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_accessmethod(data, token, signal) {
  const apiUrl = `${API_URL}accessmethod/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_accessmethod_list(school_id, token, signal) {
  let apiUrl = `${API_URL}accessmethod-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================Device======================================
export function get_deviceregister(
  page,
  page_size,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}device/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_deviceregister(data, school_id, token, signal) {
  const apiUrl = `${API_URL}device/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_deviceregister(data, token, signal) {
  const apiUrl = `${API_URL}device/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_deviceregister(data, token, signal) {
  const apiUrl = `${API_URL}device/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_deviceregister_list(school_id, token, signal) {
  let apiUrl = `${API_URL}device-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================register user list======================================

export function get_register_user_list(
  role,
  school_class,
  section,
  token,
  signal
) {
  let apiUrl = `${API_URL}register-user-list/?`;
  const params = [];
  if (role) params.push(`role=${role}`);
  if (school_class) params.push(`school_class=${school_class}`);
  if (section) params.push(`section=${section}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================Gate Type======================================
export function get_gatetype(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}gatetype/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_gatetype(data, school_id, token, signal) {
  const apiUrl = `${API_URL}gatetype/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_gatetype(data, token, signal) {
  const apiUrl = `${API_URL}gatetype/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_gatetype(data, token, signal) {
  const apiUrl = `${API_URL}gatetype/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_gatetype_list(school_id, token, signal) {
  let apiUrl = `${API_URL}gatetype-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================user-access======================================
export function get_useraccesspass(user_id, school_id, token, signal) {
  let apiUrl = `${API_URL}user-accesspass/?`;
  const params = [];
  if (user_id) params.push(`user_id=${user_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_useraccesspass(data, school_id, token, signal) {
  const apiUrl = `${API_URL}user-accesspass/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function delete_useraccesspass(data, token, signal) {
  const apiUrl = `${API_URL}user-accesspass/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================gate parseScale=====================================
export function get_gatepass(
  page,
  page_size,
  user_id,
  type,
  method,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}gatepass/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);

  if (user_id) params.push(`user_id=${user_id}`);
  if (type) params.push(`type=${type}`);
  if (method) params.push(`method=${method}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_getpass(data, school_id, token, signal) {
  const apiUrl = `${API_URL}gatepass/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function delete_gatepass(data, token, signal) {
  const apiUrl = `${API_URL}gatepass/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================qr code detail=======================
export function get_detailfromQr(encrypted_user_id, signal) {
  let apiUrl = `${API_URL}qr-detail/?`;
  const params = [];
  if (encrypted_user_id) params.push(`encrypted_user_id=${encrypted_user_id}`);
  apiUrl += params.join("&");
  return fetchWithoutTokenData(apiUrl, signal);
}
export function mark_attendance_by_qr(
  encrypted_user_id,
  data,
  token,
  school_id,
  signal
) {
  let apiUrl = `${API_URL}qr-attendance/?`;
  const params = [];
  if (encrypted_user_id) params.push(`encrypted_user_id=${encrypted_user_id}`);
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
// ============================bulk register card===============================
export function bulk_register_in_device(data, school_id, token, signal) {
  let apiUrl = `${API_URL}add-multiple-employee/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function add_user_register_in_device(data, school_id, token, signal) {
  let apiUrl = `${API_URL}add-single-employee/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function block_user_from_device(data, school_id, token, signal) {
  let apiUrl = `${API_URL}block-single-employee/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function delete_user_from_device(data, school_id, token, signal) {
  let apiUrl = `${API_URL}delete-single-employee/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
// ============================rfid card===============================
export function add_rfid_card(data, user_id, school_id, token, signal) {
  let apiUrl = `${API_URL}add-employee/?`;
  const params = [];
  if (user_id) params.push(`user_id=${user_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function remove_rfid_card(data, user_id, school_id, token, signal) {
  let apiUrl = `${API_URL}user-block-access/?`;
  const params = [];
  if (user_id) params.push(`user_id=${user_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

// ================================visitor======================================
export function get_visitor(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}visitor/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_visitor(data, school_id, token, signal) {
  const apiUrl = `${API_URL}visitor/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_visitor(data, token, signal) {
  const apiUrl = `${API_URL}visitor/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_visitor(data, token, signal) {
  const apiUrl = `${API_URL}visitor/`;
  return deletData(apiUrl, data, token, signal);
}

//  ======================role base user=================
export function get_rolebyuser(
  page,
  page_size,
  role,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}role-by-user/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (role) params.push(`role=${role}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_rolebyuser(data, school_id, role, token, signal) {
  let apiUrl = `${API_URL}role-by-user/?`;
  const params = [];
  if (role) params.push(`role=${role}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_rolebyuser(data, token, school_id, signal) {
  let apiUrl = `${API_URL}role-by-user/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_rolebyuser(data, token, signal) {
  const apiUrl = `${API_URL}role-by-user/`;
  return deletData(apiUrl, data, token, signal);
}
// ==========================get filter list================
export function get_filter_list(model, fields, token, signal) {
  let apiUrl = `${API_URL}filter-list/?`;
  const params = [];
  if (model) params.push(`model=${model}`);
  if (fields) params.push(`fields=${fields}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export async function get_import_sample(model, token, school_id) {
  let apiUrl = `${API_URL}import/?model=${model}&school_id=${school_id}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `token ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch the sample file.");
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get("content-disposition");

    return { status: true, blob, contentDisposition };
  } catch (error) {
    return { status: false, response: error.message };
  }
}

export function add_import_file(model, data, token, school_id, signal) {
  let apiUrl = `${API_URL}import/?`;
  const params = [];
  if (model) params.push(`model=${model}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDataMultiForm(apiUrl, data, token, signal);
}

// ================================vehicle======================================
export function get_vehicle(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}vehicles/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_vehicle(data, school_id, token, signal) {
  const apiUrl = `${API_URL}vehicles/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_vehicle(data, token, signal) {
  const apiUrl = `${API_URL}vehicles/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_vehicle(data, token, signal) {
  const apiUrl = `${API_URL}vehicles/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_vehicle_list(school_id, token, signal) {
  let apiUrl = `${API_URL}vehicle-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_driver_vehicle(token, signal) {
  const apiUrl = `${API_URL}driver-vehicles-check/?`;
  return fetchData(apiUrl, token, signal);
}
// ===================================vehicle passenger=====================
export function get_vehicle_passenger(school_id, vehicle_id, token, signal) {
  let apiUrl = `${API_URL}vehicle-passenger/?`;
  const params = [];
  if (vehicle_id) params.push(`vehicle_id=${vehicle_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_vehicle_passenger(data, school_id, token, signal) {
  const apiUrl = `${API_URL}vehicle-passenger/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
// ===================================bus stations=====================
export function get_busStation(vehicle_id, token, signal) {
  let apiUrl = `${API_URL}bus-stations/?`;
  const params = [];
  if (vehicle_id) params.push(`vehicle_id=${vehicle_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_busStation(data, token, signal) {
  const apiUrl = `${API_URL}bus-stations/`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function update_busStation(data, token, signal) {
  const apiUrl = `${API_URL}bus-stations/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_busStation(data, token, signal) {
  const apiUrl = `${API_URL}bus-stations/`;
  return deletData(apiUrl, data, token, signal);
}
// ===================================bus route=====================
export function get_busroute(vehicle_id, token, signal) {
  let apiUrl = `${API_URL}bus-routes/?`;
  const params = [];
  if (vehicle_id) params.push(`vehicle_id=${vehicle_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_busroute(data, vehicle_id, token, signal) {
  const apiUrl = `${API_URL}bus-routes/?vehicle_id=${vehicle_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function get_vehicle_route(vehicle_number, token, signal) {
  let apiUrl = `${API_URL}vehicle-routes/?`;
  const params = [];
  if (vehicle_number) params.push(`vehicle_number=${vehicle_number}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function get_place_name_from_map(lat, lng, token, signal) {
  let apiUrl = `${API_URL}map-place-name/?`;
  const params = [];
  if (lat) params.push(`lat=${lat}`);
  if (lng) params.push(`lng=${lng}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
// ================================assessment======================================
export function get_assessments(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}assessments/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_assessments(data, school_id, token, signal) {
  const apiUrl = `${API_URL}assessments/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_assessments(data, token, signal) {
  const apiUrl = `${API_URL}assessments/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_assessments(data, token, signal) {
  const apiUrl = `${API_URL}assessments/`;
  return deletData(apiUrl, data, token, signal);
}

export function get_assessments_questions(
  page,
  page_size,
  ass_id,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}assessments/{ass_id}?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (ass_id) params.push(`ass_id=${ass_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================assessment======================================
export function get_homework(page, page_size, school_id, token, signal) {
  let apiUrl = `${API_URL}homework/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_homework(data, school_id, token, signal) {
  const apiUrl = `${API_URL}homework/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_homework(data, token, signal) {
  const apiUrl = `${API_URL}homework/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_homework(data, token, signal) {
  const apiUrl = `${API_URL}homework/`;
  return deletData(apiUrl, data, token, signal);
}

export function get_homework_withId(
  page,
  page_size,
  school_id,
  token,
  signal,
  subject
) {
  let apiUrl = `${API_URL}homework/?subject=${subject}`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (subject) params.push(`subject=${subject}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_homework_filterBy(
  page,
  page_size,
  school_id,
  token,
  signal,
  filter_by
) {
  let apiUrl = `${API_URL}homework/?filter_by=${filter_by}`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (filter_by) params.push(`filter_by=${filter_by}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_homework_filtercreated_at(
  page,
  page_size,
  school_id,
  token,
  signal,
  created_at
) {
  let apiUrl = `${API_URL}homework/?created_at=${created_at}`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (created_at) params.push(`created_at=${created_at}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================bAssessment======================================

export function get_submission(
  page,
  page_size,
  search,
  assignment_id,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}submission/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);
  if (assignment_id) params.push(`assignment_id=${assignment_id}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_submission(data, school_id, token, signal) {
  const apiUrl = `${API_URL}submission/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_submission(data, token, signal) {
  const apiUrl = `${API_URL}submission/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_submission(data, token, signal) {
  const apiUrl = `${API_URL}submission/`;
  return deletData(apiUrl, data, token, signal);
}
export function get_assignment(
  page,
  page_size,
  search,
  school_id,
  filter_fields,
  token,
  signal
) {
  let apiUrl = `${API_URL}assignment/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);
  if (filter_fields) {
    Object.entries(filter_fields).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        // For each item, create a separate key=value pair
        value.forEach((v) => {
          params.push(`${key}=${encodeURIComponent(v)}`);
        });
      } else if (typeof value === "string" && value.trim() !== "") {
        params.push(`${key}=${encodeURIComponent(value)}`);
      }
    });
  }
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_assignment(data, school_id, token, signal) {
  const apiUrl = `${API_URL}assignment/?school_id=${school_id}`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_assignment(data, token, signal) {
  const apiUrl = `${API_URL}assignment/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_assignment(data, token, signal) {
  const apiUrl = `${API_URL}assignment/`;
  return deletData(apiUrl, data, token, signal);
}
export function delete_assignment_attachment(data, token, signal) {
  const apiUrl = `${API_URL}assignment-attachment/`;
  return deletData(apiUrl, data, token, signal);
}
// ================================= DUe Reports ====================

export function get_due_reports(school_id, session_id, token, signal) {
  let apiUrl = `${API_URL}due-report/?`;
  const params = [];

  if (school_id) params.push(`school_id=${school_id}`);
  if (session_id) params.push(`session_id=${session_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_class_due_reports(
  school_id,
  class_id,
  section_id,
  session_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}class-due-report/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  if (class_id) params.push(`class_id=${class_id}`);
  if (section_id) params.push(`section_id=${section_id}`);
  if (session_id) params.push(`session_id=${session_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function Exam_Result(examid, token, signal) {
  let apiUrl = `${API_URL}exam-result/?exam=${examid}`;
  const params = [];
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_Exam_Result(data, school_id, token, signal) {
  console.log("uuuuu", data);
  const apiUrl = `${API_URL}exam-result/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function get_Bulk_Result(exam_id, school_id, token, signal) {
  let apiUrl = `${API_URL}bulk-result/?exam=${exam_id}`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  // if (exam_id) params.push(`exam_id=${exam_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function add_Bulk_Result(data, token, signal) {
  const apiUrl = `${API_URL}bulk-result/?`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function post_Time_Table(data, token, signal) {
  const apiUrl = `${API_URL}newtimetable/?`;
  return putData(apiUrl, data, token, signal);
}

// ==============================DOwnLoadsampleFile ==================================================

export function Download_sample_file(exam_id, school_id, token, signal) {
  console.log("SchoolId11", school_id);
  let apiUrl = `${API_URL}bulk-result/?exam=${exam_id}`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  // if (exam_id) params.push(`exam_id=${exam_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// =================================report templates=========================

export function get_report_template_list(school_id, token, signal) {
  let apiUrl = `${API_URL}report-templates-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function get_report_template(token, type, school_id, signal) {
  let apiUrl = `${API_URL}report-templates/?`;
  const params = [];
  if (type) params.push(`type=${type}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_report_template(data, token, signal) {
  const apiUrl = `${API_URL}report-templates/`;
  return PostDataMultiForm(apiUrl, data, token, signal);
}
export function update_report_template(data, token, signal) {
  const apiUrl = `${API_URL}report-templates/`;
  return putData(apiUrl, data, token, signal);
}
export function delete_report_template(data, token, signal) {
  const apiUrl = `${API_URL}report-templates/`;
  return deletData(apiUrl, data, token, signal);
}

export function add_template_to_school(data, token, school_id, signal) {
  let apiUrl = `${API_URL}school-templates/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDataMultiForm(apiUrl, data, token, signal);
}

// =========================Genrate All Reports ==============================
export function fetch_report_student_mobile(
  schools_id,
  school_class,
  student_id,
  subject_id,
  gender,
  token,
  signal
) {
  let apiUrl = `${API_URL}students-mobile/
  ?school_class=${school_class}?student_id=${student_id} subject=${subject_id} gender=${gender}`;
  const params = [];
  if (schools_id) params.push(`schools_id=${schools_id}`);
  if (school_class) params.push(`school_class=${school_class}`);
  if (student_id) params.push(`student_id=${student_id}`);
  if (subject_id) params.push(`subject_id=${subject_id}`);
  if (gender) params.push(`gender=${gender}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function fetch_student_subject_report(
  schools_id,
  class_name,
  subject_name,
  token,
  signal
) {
  let apiUrl = `${API_URL}students-subject-report/
  ?class_name=${class_name}?subject=${subject_name}`;
  const params = [];
  if (schools_id) params.push(`schools_id=${schools_id}`);
  if (class_name) params.push(`class_name=${class_name}`);
  if (subject_name) params.push(`subject_name=${subject_name}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

export function fetch_student_id_card(schools_id, idcard_issue, token, signal) {
  let apiUrl = `${API_URL}students-id-card/
  ?idcard_issue=${idcard_issue}`;
  const params = [];
  if (schools_id) params.push(`schools_id=${schools_id}`);
  if (idcard_issue) params.push(`idcard_issue=${idcard_issue}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// export function fetch_student_add_report(schools_id,admission_date,year,school_class,token, signal) {
//   let apiUrl = `${API_URL}student-add-report/
//   ?admission_date=${admission_date}?year=${year} school_class=${school_class}`;
//   const params = [];
//   if (schools_id) params.push(`schools_id=${schools_id}`);
//   if (admission_date) params.push(`admission_date=${admission_date}`);
//   if (year) params.push(`year=${year}`);
//   if (school_class) params.push(`school_class=${school_class}`);
//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function fetch_date_wise_fee_reciept(schools_id,
//    student_name,student_id,school_class,section,start_date,end_date,on_date,token,signal) {
//   let apiUrl = `${API_URL}student-add-report/
//   ?student_name=${student_name}?student_id=${student_id} school_class=${school_class}?section=${section}?start_date=${start_date}?end_date=${end_date}?on_date=${on_date}`;
//   const params = [];
//   if (schools_id) params.push(`schools_id=${schools_id}`);
//   if (student_name) params.push(`student_name=${student_name}`);
//   if (student_id) params.push(`student_id=${student_id}`);
//   if (school_class) params.push(`school_class=${school_class}`);
//   if (section) params.push(`section=${section}`);

//   if (start_date) params.push(`start_date=${start_date}`);

//   if (end_date) params.push(`end_date=${end_date}`);

//   if (on_date) params.push(`on_date=${on_date}`);

//   apiUrl += params.join("&");
//   return fetchData(apiUrl, token, signal);
// }

// export function fetch_installmentwise_fee_reciept(schools_id,
//   student_id,school_class,section,start_date,end_date,on_date,token,signal) {
//  let apiUrl = `${API_URL}student-add-report/
//  ??student_id=${student_id} school_class=${school_class}?section=${section}?start_date=${start_date}?end_date=${end_date}?on_date=${on_date}`;
//  const params = [];
//  if (schools_id) params.push(`schools_id=${schools_id}`);
//  if (student_id) params.push(`student_id=${student_id}`);
//  if (school_class) params.push(`school_class=${school_class}`);
//  if (section) params.push(`section=${section}`);

//  if (start_date) params.push(`start_date=${start_date}`);

//  if (end_date) params.push(`end_date=${end_date}`);

//  if (on_date) params.push(`on_date=${on_date}`);

//  apiUrl += params.join("&");
//  return fetchData(apiUrl, token, signal);
// }

// ===========================================pay slip =============================
export function get_pay_receipt(
  page,
  page_size,
  search,
  user,
  filter_fields,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}pay-receipt/?`;
  const params = [];
  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (user) params.push(`user=${user}`);

  if (search) params.push(`search=${search}`);
  if (filter_fields) params.push(`filter_fields=${filter_fields}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}

// ===========================================pay slip html =============================
export function get_pay_receipt_html(id, school_id, token, signal) {
  let apiUrl = `${API_URL}pay-receipt-html/?`;
  const params = [];
  if (id) params.push(`id=${id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}
export function get_fee_card_html(student_id, school_id, token, signal) {
  let apiUrl = `${API_URL}fee-card-html/?`;
  const params = [];
  if (student_id) params.push(`student_id=${student_id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}
//   =======================get student category ===============================
export function get_quick_action(school_id, token, signal) {
  let apiUrl = `${API_URL}quick-action/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_quick_action(data, school_id, token, signal) {
  const apiUrl = `${API_URL}quick-action/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}
export function delete_quick_action(data, school_id, token, signal) {
  const apiUrl = `${API_URL}quick-action/?school_id=${school_id}`;
  return deletData(apiUrl, data, token, signal);
}

// =================count========================================
export function get_bank_metrics(data, school_id, token, signal) {
  const apiUrl = `${API_URL}bank-metric/?school_id=${school_id}`;
  return PostDatawithToken(apiUrl, data, token, signal);
}

// ===============================Manual Gate pass=============================
export function get_manualgatepass(
  page,
  page_size,
  school_id,
  search,
  token,
  signal
) {
  let apiUrl = `${API_URL}manual-gate-pass/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_manualgatepass(data, school_id, token, signal) {
  let apiUrl = `${API_URL}manual-gate-pass/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_manualgatepass(data, school_id, token, signal) {
  let apiUrl = `${API_URL}manual-gate-pass/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PutDataMultiForm(apiUrl, data, token, signal);
}
export function delete_manualgatepass(data, school_id, token, signal) {
  let apiUrl = `${API_URL}manual-gate-pass/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_manual_gatepass_html(id, school_id, token, signal) {
  let apiUrl = `${API_URL}manual-gate-pass-html/?`;
  const params = [];
  if (id) params.push(`id=${id}`);
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}

// ===============================Inventory Category=============================
export function get_inventorycategory(
  page,
  page_size,
  school_id,
  search,
  token,
  signal
) {
  let apiUrl = `${API_URL}invnt-catg/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_inventorycategory(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-catg/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_inventorycategory(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-catg/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_inventorycategory(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-catg/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_inventorycategory_list(school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-catg-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ===============================Inventory Sub Category=============================
export function get_inventorysubcategory(
  page,
  page_size,
  school_id,
  search,
  token,
  signal
) {
  let apiUrl = `${API_URL}invnt-sub-catg/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_inventorysubcategory(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-sub-catg/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_inventorysubcategory(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-sub-catg/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_inventorysubcategory(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-sub-catg/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_inventorysubcategory_list(school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-sub-catg-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ===============================Inventory Unit=============================
export function get_inventoryunit(
  page,
  page_size,
  school_id,
  search,
  token,
  signal
) {
  let apiUrl = `${API_URL}invnt-unit/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_inventoryunit(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-unit/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_inventoryunit(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-unit/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_inventoryunit(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-unit/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_inventoryunit_list(school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-unit-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ===============================Inventory item=============================
export function get_inventoryitem(
  page,
  page_size,
  school_id,
  search,
  token,
  signal
) {
  let apiUrl = `${API_URL}invnt-item/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);
  if (search) params.push(`search=${search}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_inventoryitem(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-item/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PostDataMultiForm(apiUrl, data, token, signal);
}

export function update_inventoryitem(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-item/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return PutDataMultiForm(apiUrl, data, token, signal);
}
export function delete_inventoryitem(data, school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-item/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
export function get_inventoryitem_list(school_id, token, signal) {
  let apiUrl = `${API_URL}invnt-item-list/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);
  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}

// ================================Fee package======================================
export function get_examsubjectfield(
  page,
  page_size,
  school_id,
  token,
  signal
) {
  let apiUrl = `${API_URL}exam-marks-field/?`;
  const params = [];

  if (page) params.push(`page=${page}`);
  if (page_size) params.push(`page_size=${page_size}`);
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return fetchData(apiUrl, token, signal);
}
export function add_examsubjectfield(data, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-marks-field/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return PostDatawithToken(apiUrl, data, token, signal);
}

export function update_examsubjectfield(data, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-marks-field/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
export function delete_examsubjectfield(data, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-marks-field/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return deletData(apiUrl, data, token, signal);
}
// ================================enter marks===========================================
export function get_student_mark_list(
  search,
  school_id,
  token,
  formdata,
  signal
) {
  let apiUrl = `${API_URL}exam-marks/?`;
  const params = [];
  if (search) params.push(`search=${search}`);
  if (school_id) params.push(`school_id=${school_id}`);
  for (const key in formdata) {
    const value = formdata[key];

    // Include value if it's not undefined or null
    if (value !== undefined && value !== null && value !== "") {
      params.push(`${key}=${value}`);
    }
  }
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}

export function update_student_mark(data, school_id, token, signal) {
  let apiUrl = `${API_URL}exam-marks/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}


// ================================Activity enter marks===========================================
export function get_student_activity_mark_list(
  search,
  school_id,
  token,
  formdata,
  signal
) {
  let apiUrl = `${API_URL}activity-marks/?`;
  const params = [];
  if (search) params.push(`search=${search}`);
  if (school_id) params.push(`school_id=${school_id}`);
  for (const key in formdata) {
    const value = formdata[key];

    // Include value if it's not undefined or null
    if (value !== undefined && value !== null && value !== "") {
      params.push(`${key}=${value}`);
    }
  }
  apiUrl += params.join("&");

  return fetchData(apiUrl, token, signal);
}

export function update_student_activity_mark(data, school_id, token, signal) {
  let apiUrl = `${API_URL}activity-marks/?`;
  const params = [];
  if (school_id) params.push(`school_id=${school_id}`);

  apiUrl += params.join("&");
  return putData(apiUrl, data, token, signal);
}
